import styles from './Jiopay.module.scss';
import { useContext } from 'react';
import OverviewContext from 'store/overview-context';

const Jiopay = () => {
    const { overviewData, createObj } = useContext(OverviewContext);

    return (
        <div className={styles.container}>
            <iframe title='jiopay' src={`${process.env.REACT_APP_BASE_URL}/payments/v1/jiopay/initiateTransaction?c_id=${overviewData.c_id}&bd_token=${overviewData.bd_token}&ts_amount=${createObj?.ts_amount}`}></iframe>
        </div>
    )
}

export default Jiopay;